module.exports = __webpack_public_path__ + "static/media/flag-angola.76797d59.jpg";